import React, { useState, useEffect } from 'react';
import { Filter, Search, Star, MapPin, TrendingUp, Flame, Award, Heart, Eye, ThumbsUp, ShoppingCart, Bell, Zap, Target, Sparkles,  ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import { useTheme } from '../arrangement/ThemeContext';
import API_URL from '../config/ApiUrl';
export const TrendingSidebar = ({ onSearchClick }) => {
  const [trendingData, setTrendingData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { colors } = useTheme();
  useEffect(() => {
    const fetchTrendingData = async () => {
      try {
        const response = await fetch(`${API_URL}/api/trending-strains`);
        const data = await response.json();
        setTrendingData(data);
      } catch (error) {
        console.error('Failed to fetch trending data:', error);
        // Fallback to hardcoded data
        setTrendingData([
          { term: "Blue Dream", count: 234 },
          { term: "OG Kush", count: 189 },
          { term: "White Widow", count: 156 },
          { term: "Sour Diesel", count: 134 }
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchTrendingData();
  }, []);

  const handleSearchClick = (searchTerm) => {
    if (onSearchClick) {
      onSearchClick(searchTerm);
    }
  };

  if (loading) {
    return (
      <div style={{ /* your existing styles */ }}>
        <div style={{ padding: '20px', textAlign: 'center', color: '#888' }}>
          Loading trending...
        </div>
      </div>
    );
  }

  return (
    <div style={{
      background: colors.comeCard,
      border: '1px solid #333',
      borderRadius: '16px',
      marginTop: '24px'
    }}>
      <div style={{
        padding: '20px',
        borderBottom: '1px solid #333'
      }}>
        <h3 style={{
          fontWeight: '600',
          margin: 0,
          color: '#e5e5e5',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <TrendingUp size={18} style={{ color: '#8b5cf6' }} />
          Popular Strains
        </h3>
      </div>
      <div style={{ padding: '16px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {trendingData.map((item, index) => (
            <div
              key={index}
              onClick={() => handleSearchClick(item.term)}
              style={{
                padding: '12px',
                background: colors.comeCard,
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                border: '1px solid #333'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#00d4aa';
                e.currentTarget.style.transform = 'translateX(4px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#333';
                e.currentTarget.style.transform = 'translateX(0)';
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ color: '#e5e5e5', fontSize: '14px' }}>{item.term}</span>
                <span style={{ color: '#888', fontSize: '12px' }}>{item.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};